import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { List, ListItem, Typography, Paper } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const API_URL = process.env.REACT_APP_API_ROOT || 'http://localhost:4000';

const MyExpressions = ({ expression, updateExpression }) => {
    const [expressions, setExpressions] = useState([]);
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        const fetchExpressions = async () => {
            try {
                const token = await getAccessTokenSilently();

                await axios.get(`${API_URL}/api/simulations/expression`, {

                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }).then(response => {
                    console.log("Fetched expressions:", response.data);
                    setExpressions(response.data);
                });

            } catch (error) {
                console.error("Error fetching expressions", error);
            }
        };
        if (isAuthenticated) {
            fetchExpressions();
        }

    }, [expression, isAuthenticated, getAccessTokenSilently]);

    const handleDeleteExpression = async (event) => {
        event.stopPropagation(); // Prevent the click from propagating to the ListItem  
        console.log(event);

        const token = await getAccessTokenSilently();
        const expressionId = event.target.getAttribute('data-id'); // Get the ID of the expression to delete
        console.log("Deleting expression with ID:", expressionId);

        await axios.delete(`${API_URL}/api/simulations/expression/${expressionId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            console.log("Expression deleted:", response.data);
            expressions.filter(exp => exp._id !== expressionId); // Update the state to remove the deleted expression
        }).catch(error => {
            console.error("Error deleting expression:", error);
        });
        setExpressions(expressions.filter(exp => exp._id !== expressionId)); // Update the state to remove the deleted expression
    };

    if (!isAuthenticated) {
        return (
            <Paper elevation={3} sx={{ p: 2, height: 'auto', minHeight: '200px' }}>
                <Typography variant="h6" align="center" sx={{ mb: 2 }}>My Expressions</Typography>
                <Typography variant="body1" align="center">You must be logged in to see your expressions.</Typography>
            </Paper>
        );
    }

    return (
        <Paper elevation={3} sx={{ p: 2, height: 'auto' }}>
            <Typography variant="h6" align="center" sx={{ mb: 2 }}>My Expressions</Typography>
            <List sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {expressions.map((exp, index) => (
                    <ListItem key={index} onClick={() => updateExpression(exp.expression)} sx={{ cursor: 'pointer', mb: 1, border: '1px solid', borderColor: 'grey.300', borderRadius: 2, p: 2 }}>
                        <div style={{ position: 'relative', width: '100%' }}>
                            <div
                                data-id={exp._id}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0,
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    padding: '0 4px'
                                }}
                                onClick={handleDeleteExpression}
                            >
                                x
                            </div>

                            <Typography variant="body3" sx={{ display: 'flex', alignItems: 'center' }}>
                                {exp.expression.map((op, id) => (
                                    <React.Fragment key={id}>
                                        {id === 0 ? (
                                            <ArrowRightIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                        ) : (
                                            " + "
                                        )}
                                        {op.name}
                                    </React.Fragment>
                                ))}
                            </Typography>
                        </div>
                    </ListItem>
                ))}
            </List>
        </Paper>
    );
};

export default MyExpressions;
